import React from 'react';
const svgProps = {
  'aria-hidden': true as const,
  focusable: 'false' as const
};
export function CheckIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...svgProps} role="img" data-id="element-468">
      <polyline points="20 6 9 17 4 12" data-id="element-469" />
    </svg>;
}
export function XIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...svgProps} role="img" data-id="element-470">
      <line x1="18" y1="6" x2="6" y2="18" data-id="element-471" />
      <line x1="6" y1="6" x2="18" y2="18" data-id="element-472" />
    </svg>;
}
export function StarIcon({
  className = '',
  fill = 'none'
}: {
  className?: string;
  fill?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill={fill} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...svgProps} role="img" data-id="element-473">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-474" />
    </svg>;
}
export function ShieldCheckIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...svgProps} role="img" data-id="element-475">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-476" />
      <polyline points="9 12 11 14 15 10" data-id="element-477" />
    </svg>;
}
export function ZapIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...svgProps} role="img" data-id="element-478">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" data-id="element-479" />
    </svg>;
}
export function ArrowRightIcon({
  className = '',
  strokeWidth = 2
}: {
  className?: string;
  strokeWidth?: number;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" {...svgProps} role="img" data-id="element-480">
      <line x1="5" y1="12" x2="19" y2="12" data-id="element-481" />
      <polyline points="12 5 19 12 12 19" data-id="element-482" />
    </svg>;
}
export function CrownIcon({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...svgProps} role="img" data-id="element-483">
      <path d="M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7z" data-id="element-484" />
      <path d="M3 20h18" data-id="element-485" />
    </svg>;
}